import 'reflect-metadata';

import { injectable } from 'inversify';

import { AxiosConfig, UseFetchArgs } from '@project44/ui-utils';
import { DtoBase } from '@project44-models/iam-gateway';

import { IModifiedAxiosRequestConfig } from '../../../../shared/core/infrastructrue/types';

@injectable()
export class ModifiedAxiosRequestConfigAdapter {
  public toUseFetchArgs<T>(payload: {
    modifiedAxiosRequestConfig: IModifiedAxiosRequestConfig<T>;
  }): UseFetchArgs<DtoBase<T>> {
    const { url, baseURL, dtoAdapter, params } =
      payload.modifiedAxiosRequestConfig;

    const useFetchUrl = new URL(
      `${url}${!!params ? `?${params.toString()}` : ''}`,
      baseURL,
    );

    return {
      url: useFetchUrl.toString(),
      // @ts-expect-error in arguments due to changes from an external lib
      deserializer: dtoAdapter,
      swrConfig: {
        revalidateIfStale: true,
        revalidateOnFocus: true,
        revalidateOnMount: true,
        revalidateOnReconnect: true,
      },
    };
  }

  public toNullableUseFetchArgs<T>(): UseFetchArgs<T> {
    return {
      url: null,
    };
  }

  public toUseAxiosConfig<T>(payload: {
    modifiedAxiosRequestConfig: IModifiedAxiosRequestConfig<T>;
  }): AxiosConfig {
    const { axiosBodyPayload, ...restOfModifiedAxiosRequestConfig } =
      payload.modifiedAxiosRequestConfig;

    return {
      ...restOfModifiedAxiosRequestConfig,
      data: axiosBodyPayload,
      params: payload.modifiedAxiosRequestConfig.urlSearchParams,
      paramsSerializer: undefined,
      adapter: undefined,
      cancelToken: undefined,
      transitional: undefined,
      // @ts-expect-error since useAxios throws error on 'GET'
      method: payload.modifiedAxiosRequestConfig.method,
    };
  }
}
